document.addEventListener("DOMContentLoaded", function () {
  let scriptLoaded = false;
  let slimScrollInitialized = false;
  let interactionTimeout;
  let facetsWrapperDesktop = document.querySelector('#FacetsWrapperDesktop');
  let facetFiltersForm = facetsWrapperDesktop.closest('#FacetFiltersForm');
  let $facetsWrapperDesktopEl = $(facetsWrapperDesktop);
  let rafId = null;
  let timeoutId = null;

  let jsSrc = facetsWrapperDesktop.getAttribute('data-js-src');

  // List of Script tag URLs
  const scriptUrls = [
    jsSrc,
  ];

  // List of CSS links URLs
  function humanInteraction() {
    if (!scriptLoaded) {
      let output = false;

      // Check and inject javascript
      const hasValidScripts = scriptUrls.some((url) => url && url !== 'Add Your Script Link Here');
      if (hasValidScripts) {
        scriptUrls.forEach((url) => {
          if (url && url !== 'Add Your Script Link Here') {
            let script = document.createElement('script');
            script.src = url;
            document.head.appendChild(script);
            script.onload = function () {
              // console.log("SlimScrollBar.js 脚本加载完成");
              initSlimScrollBar();
            };
            output = true;
          }
        });
      }

      if (output) {
        console.log('SlimScrollBar.js load.');
      } else {
        console.warn('Keihen: No valid script or style URLs found.');
      }

      scriptLoaded = true;
      clearTimeout(interactionTimeout);
    }
  }

  document.addEventListener('click', humanInteraction);
  document.addEventListener('scroll', humanInteraction);
  document.addEventListener('mousemove', humanInteraction);
  document.addEventListener('keydown', humanInteraction);
  document.addEventListener('touchstart', humanInteraction);

  // Set a timeout to trigger the script after 40 seconds of inactivity
  interactionTimeout = setTimeout(function () {
    if (!scriptLoaded) {
      humanInteraction();
    }
  }, 40000);

  function setVisibleHeight() {
    if (window.innerWidth >= 749 && $facetsWrapperDesktopEl.length > 0) {
      let windowHeight = window.innerHeight;
      let tempDistance = facetsWrapperDesktop.getBoundingClientRect().top;
      let topDistance = tempDistance > 0 ? tempDistance : 0;
      let visibleHeight = windowHeight - topDistance - 50;
      facetFiltersForm.style.cssText = `height: ${visibleHeight}px;overflow: hidden; max-height: 100%;`;
    } else {
      facetFiltersForm.style.cssText = `height: auto;overflow: unset; max-height: unset;`;
    }
  }

  function handleScroll() {
    // 立即取消未执行的动画帧，避免堆积
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    // 安排下一帧执行，保证60fps的流畅度
    rafId = requestAnimationFrame(setVisibleHeight);
    // 处理滚动停止
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      // 滚动停止后确保更新
      if (rafId) {
        cancelAnimationFrame(rafId);
        setVisibleHeight();
        rafId = null;
      }
    }, 100);
  }

  function initSlimScrollBar() {
    let windowWidth = window.innerWidth;
    if (windowWidth >= 749 && $facetsWrapperDesktopEl.length > 0 && !slimScrollInitialized) {
      setVisibleHeight();

      slimScrollInitialized = true;
      $facetsWrapperDesktopEl.slimScroll({
        width: 'auto', //可滚动区域宽度
        height: '100%', //可滚动区域高度
        size: '2px', //组件宽度
        color: '#B8B4B2', //滚动条颜色
        position: 'right', //组件位置：left/right
        distance: '0px', //组件与侧边之间的距离
        start: 'top', //默认滚动位置：top/bottom
        opacity: 1, //滚动条透明度
        alwaysVisible: false, //是否 始终显示组件
        disableFadeOut: true, //是否 鼠标经过可滚动区域时显示组件，离开时隐藏组件
        railVisible: true, //是否 显示轨道
        railColor: '#E8E7E6', //轨道颜色
        railOpacity: 1, //轨道透明度
        railDraggable: true, //是否 滚动条可拖动
        railClass: 'slimScrollRail', //轨道div类名 
        barClass: 'slimScrollBar', //滚动条div类名
        wrapperClass: 'slimScrollDiv', //外包div类名
        allowPageScroll: true, //是否 使用滚轮到达顶端/底端时，滚动窗口
        wheelStep: 10, //滚轮滚动量
        touchScrollStep: 10, //滚动量当用户使用手势
        borderRadius: '10px', //滚动条圆角
        railBorderRadius: '10px' //轨道圆角
      });
      // 添加类名，移除overflow:hidden 样式
      $facetsWrapperDesktopEl.addClass('inited');
    }
  }

  // Debounce function to optimize resize event
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  window.addEventListener('resize', debounce(initSlimScrollBar, 500));
  window.addEventListener('scroll', handleScroll, { passive: true });
});